import { render, staticRenderFns } from "./discount.component.vue?vue&type=template&id=659d6b8c&scoped=true&"
import script from "./discount.component.vue?vue&type=script&lang=ts&"
export * from "./discount.component.vue?vue&type=script&lang=ts&"
import style0 from "./discount.component.vue?vue&type=style&index=0&id=659d6b8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d6b8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDivider,VForm})
